@if (!previewModeFlag && mode !== "supplierEdit") {
  <!-- Close Button -->
  <div class="d-flex justify-content-end px-3 py-2 mb-2">
    <button type="button" class="btn-close" aria-label="Close" (click)="closeDesigner()" title="Close Designer"></button>
  </div>

  <ul class="nav nav-tabs mb-1" id="pills-tab" role="tablist">
    <li class="nav-item" role="presentation">
      <a
        class="nav-link"
        [class.active]="formdesignerLoaded"
        id="formBuilder-tab"
        data-toggle="pill"
        (click)="formdesigner()"
        role="tab"
        aria-controls="formBuilder"
        aria-selected="true"
        >Form Builder</a
      >
    </li>
    <li class="nav-item" role="presentation">
      <a
        class="nav-link"
        [ngClass]="{ disabled: !doQuestionsExist() }"
        [class.active]="conditionallogicLoaded"
        id="conditionalLogic-tab"
        data-toggle="pill"
        (click)="conditionallogic()"
        role="tab"
        aria-controls="conditionalLogic"
        aria-selected="false"
        >Logic Builder</a
      >
    </li>
    <li class="nav-item" role="presentation">
      <a
        class="nav-link"
        [class.active]="showAttributeMapperTab"
        [class.disabled]="!doQuestionsExist()"
        id="attribute-mapper-tab"
        data-toggle="pill"
        (click)="goToAttributeMapperTab()"
        role="tab"
        aria-controls="attribute-mapper-tab"
        [attr.aria-selected]="false"
      >
        Attribute mapper
      </a>
    </li>
  </ul>
}
<div class="tab-content" id="pills-tabContent">
  @if (formdesignerLoaded) {
    <div>
      <form-builder></form-builder>
    </div>
  }
  @if (conditionallogicLoaded) {
    <div>
      <questions></questions>
    </div>
  }
  @if (showAttributeMapperTab) {
    <attribute-mapper></attribute-mapper>
  }
</div>

<ng-template #confirmMdl let-modal>
  <!-- <div class="modal fade" id="myModal" role="dialog">
      <div class="modal-dialog"> -->

  <!-- Modal content-->
  <div class="modal-content">
    <div class="modal-header">
      <!-- <button type="button" #closebutton class="close" data-dismiss="modal">&times;</button> -->
      <h4 class="modal-title">Confirmation</h4>
    </div>
    <div class="modal-body">
      <p>Please Save before you proceed</p>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-danger"
        id="closeModal"
        (click)="onCancel()"
      >
        cancel
      </button>
      <button
        type="button"
        class="btn btn-primary"
        id="closeModal"
        (click)="onOk()"
      >
        ok
      </button>
    </div>
  </div>
  <!-- </div>
    </div> -->
</ng-template>
